import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/shared/ui/atoms';
interface TooltipProps {
  content: string;
  // 트리거가 행 우측 끝에 있으면 중앙 정렬(기본)은 박스가 뷰포트 밖으로 나간다.
  // 그때만 "right"로 우측 앵커한다. 기본값은 기존 동작 그대로다.
  align?: 'center' | 'right';
}
const ARROW_BASE = "before:content-[''] before:absolute before:top-[-8px] before:z-0 before:w-4 before:h-4 before:bg-white before:rotate-45 before:border-t before:border-l before:border-gray-200";
const ALIGNMENT = {
  center: {
    box: 'left-1/2 -translate-x-1/2',
    arrow: 'before:left-1/2 before:-translate-x-1/2'
  },
  right: {
    box: 'right-0',
    arrow: 'before:right-4'
  }
} as const;
const Tooltip = t0 => {
  const $ = _c(5);
  const {
    content,
    align: t1
  } = t0;
  const align = t1 === undefined ? "center" : t1;
  const alignment = ALIGNMENT[align];
  const t2 = `absolute top-full z-[10] mt-[12px] w-max max-w-[min(420px,calc(100vw-32px))] rounded border border-gray-200 bg-white px-4 py-2 ${alignment.box} ${ARROW_BASE} ${alignment.arrow}`;
  let t3;
  if ($[0] !== content) {
    t3 = <Typography size={12} whitespace="pre-line" className="relative z-10 max-w-full break-words leading-[18px] text-gray-400">{content}</Typography>;
    $[0] = content;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Tooltip;